module.exports = __webpack_public_path__ + "worksansgx-webfont.b9426d469afe56445230.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/sans/worksansgx-webfont.woff2
// module id = ./src/assets/webfonts/sans/worksansgx-webfont.woff2
// module chunks = styles